import React, { useRef, useEffect } from 'react';
import { ScrollView, ScrollViewProps } from 'react-native';
import useStore from '@/stores/useStore';
import { KeyboardAwareScrollView } from 'react-native-keyboard-controller';

const ScrollableView: React.FC<ScrollViewProps> = (props) => {
  const scrollRef = useRef<ScrollView>(null);
  const setScrollRef = useStore((state) => state.setScrollRef);

  useEffect(() => {
    if (scrollRef.current) {
      setScrollRef(scrollRef);
    }
  }, [scrollRef, setScrollRef]);

  return <KeyboardAwareScrollView ref={scrollRef} {...props} />;
};

export default ScrollableView;
